<template>
  <panel-browser
    title="Logs"
    :searchEnabled="false"
    :tabsEnabled="false"
    class="explorer-panel">

    <template slot="heading">
      <div class="level panel-heading">
        <div class="level-left">
          <svgicon
            @click="reset()"
            class="level-item link"
            name="refresh"
            width="30"
            height="30"
            color="#C4FFF9">
          </svgicon>
          <p class="level-item is-size-5 heading">Logs</p>
        </div>
        <div class="level-right" v-if="logItems.length > 0">
          <pagination
            :next="hasNext"
            :prev="hasPrev"
            :nextClick="nextPage"
            :prevClick="prevPage"
            :page="page"
            :perPage="perPage"
            :itemCount="itemCount"
            :total="total"
            :loading="loading">
          </pagination>
        </div>
      </div>
    </template>

      <alert-log-panel-item
        v-for="(log,index) in logItems"
        :key="log.id"
        :item="log"
        :related="log.parsed.related"
        @selectedPanelItem="selectIndex(index)">
      </alert-log-panel-item>

    <div slot="right" class="editor">
      <content-nav-bar>
        <alert-log-filter-bar
          ref="filterBar"
          :asset="asset"
          tagsEndpoint="primary/listLogsTags"
          storeName="logViewState"></alert-log-filter-bar>
      </content-nav-bar>
      <log v-if="selectedLog" :log="selectedLog"></log>
      <!-- <transition name="fade" mode="out-in">
        <router-view :log="selectedLog"></router-view>
      </transition> -->
    </div>
  </panel-browser>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import pagination from '@/mixins/pagination';
import PanelBrowser from '@/components/PanelBrowser.vue';
import Pagination from '@/components/Pagination.vue';
import AlertLogPanelItem from '@/components/alertlogs/AlertLogPanelItem.vue';
import Log from '@/views/logs/Log.vue';
import AlertLogFilterBar from '@/components/alertlogs/AlertLogFilterBar.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';

export default {
  name: 'Logs',
  mixins: [pagination],
  components: {
    PanelBrowser,
    AlertLogPanelItem,
    Pagination,
    Log,
    AlertLogFilterBar,
    ContentNavBar,
  },
  props: {
    asset: {
      type: Object,
      default: null,
    },
  },
  async mounted() {
    this.$bus.$on('down-arrow-pressed', () => {
      this.downArrow();
    });
    this.$bus.$on('up-arrow-pressed', () => {
      this.upArrow();
    });
    this.query = this.$route.query.q || [];
    if (this.query.length > 0) {
      this.$store.commit('logViewState/CLEAR_FILTER');
      if (typeof this.query === 'object') {
        this.query.forEach((item) => {
          this.$refs.filterBar.addRawFilter(item);
        });
      } else if (typeof this.query === 'string') {
        this.$refs.filterBar.addRawFilter(this.query);
      }
    }
    this.refresh(null);
  },
  data() {
    return {
      selectedIndex: 0,
      endpoint: 'primary/listLogs',
      logItems: [],
      query: null,
    };
  },
  computed: {
    ...mapState('logViewState', ['filterList']),
    selectedLogTitle() {
      return this.getName(this.selectedLog);
    },
    selectedLog() {
      if (this.logItems.length > 0) {
        return this.logItems[this.selectedIndex];
      }
      return null;
    },
    requestVars() {
      return {
        uuid: this.asset ? this.asset.uuid : null,
        filter: this.filter,
      };
    },
    filter() {
      const filter = {
        filters: [],
        operator: 'and',
      };
      this.filterList.forEach((f) => {
        const filterItem = f.split(':');
        if (filterItem[0] === 'tag') {
          filter.filters.push({
            log: {
              json: JSON.stringify({
                match: {
                  tags: [filterItem[1]],
                },
              }),
            },
          });
        } else if (filterItem[0] === 'eventType') {
          filter.filters.push({
            log: {
              json: JSON.stringify({
                eventType: filterItem[1],
              }),
            },
          });
        } else if (filterItem[0] === 'action') {
          filter.filters.push({
            log: {
              json: JSON.stringify({
                match: {
                  actions: [filterItem[1]],
                },
              }),
            },
          });
        }
      });
      if (Object.keys(filter.filters).length > 0) {
        return filter;
      }
      return filter;
    },
  },
  watch: {
    filter() {
      this.reset();
    },
    items() {
      this.logItems = _.map(this.items, (log) => {
        const o = Object.assign({}, log);
        o.parsed = JSON.parse(log.log);
        o.selected = false;
        return o;
      });
      // Select the first item if there is one
      if (this.logItems.length > 0) {
        this.selectIndex(0);
      }
    },
  },
  methods: {
    downArrow() {
      if ((this.selectedIndex + 1) < this.logItems.length) {
        this.selectIndex(this.selectedIndex + 1);
      }
    },
    upArrow() {
      if (this.selectedIndex > 0) {
        this.selectIndex(this.selectedIndex - 1);
      }
    },
    selectIndex(index) {
      if (this.logItems.length > 0) {
        this.logItems[this.selectedIndex].selected = false;
        this.logItems[index].selected = true;
        this.selectedIndex = index;
        // eslint-disable-next-line
      // this.$router.push({ name: 'logs.index.log.detail', params: { id: this.items[index].uuid } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.explorer-panel {
  .heading {
    color: $font-color;
    margin: 0;
  }

  .left {
    border-right: 1px solid $border-color;
  }

  .link {
    cursor: pointer;
  }
}

.editor {
  width: 100%;
  height: 100%;
}
</style>
